import { ReactComponent as ArrowPagination } from 'bzx-common/src/assets/images/fulcrum/icon_pagination.svg'
import { Button, Form } from 'bzx-common/src/ui-framework'
import { observer } from 'mobx-react'
import React from 'react'
import { Picture } from 'shared-components/Picture/Picture'

import UserProfileVM from './UserProfileVM'

export const AvatarSelector = ({ vm }: { vm: UserProfileVM }) => {
  return (
    <Form onCancel={vm.closeDialog} onSubmit={vm.closeDialog}>
      <div className="avatar-selector padded-2">
        <h3 className="title-section">Select Avatar</h3>
        <div className="grid-fluid-colmin-6em">
          {vm.currentAvatars.map((avatar) => {
            if (avatar) {
              return (
                <Button
                  key={'avatar' + avatar}
                  value={avatar}
                  variant="invisible"
                  className="user-profile__avatar-image"
                  onClickEmit="value"
                  onClick={vm.updateAvatar}
                  heigth={105}>
                  <Picture
                    src={`/images/avatars/${avatar}.png`}
                    webp={`/images/avatars/${avatar}.webp`}
                    width={105}
                    height={105}
                  />
                </Button>
              )
            }
          })}
        </div>
        <div className="pagination">
          <div
            className={`prev ${vm.avatarPagination === 0 ? `disabled` : ``}`}
            onClick={vm.prevPagination}>
            <ArrowPagination />
          </div>
          {vm.avatarPaginations.map((pagination) => (
            <Button
              size={'narrow'}
              key={'pagination' + pagination}
              variant="invisible"
              name="avatarPagination"
              value={pagination}
              onClick={vm.set}
              onClickEmit="name-value">
              <span
                className={`padded-h-1 ${
                  pagination !== vm.avatarPagination ? 'txt-muted' : 'txt-title'
                }`}>
                {++pagination}
              </span>
            </Button>
          ))}
          <div
            className={`next ${vm.isLastAvatarPagination ? `disabled` : ``}`}
            onClick={vm.nextPagination}>
            <ArrowPagination />
          </div>
        </div>
      </div>
    </Form>
  )
}

export default observer(AvatarSelector)
